import React from 'react'

const NoTeams = () => {
  return (
    <section className="container--dashboard_section teams_section">
      <h2 className="header header--section_title header-left">Teams</h2>
      <div className="container--team_list-empty">
        <h3 className="header header--no_teams_message header-left">
            You are not part of any teams. Try creating a new one.
        </h3>
      </div>
    </section>
  )
}

export default NoTeams;